module.exports = __webpack_public_path__ + "img/grasshopper.f14f76d9.png";